import {PATH} from "const/path";
export const DASHBOARD_BREADCUM = [
    {id: 1, name: 'Trang chủ', url: PATH.ADMIN_DASHBOAR},
    // {id: 2, name: 'Khách hàng', url: '#'},
    {id: 2, name: 'Dashboard', url: '#'}
]